<template>
  <form
    autocomplete="off"
    @submit.prevent="handleSubmit"
  >
    <div>
      <div class="mb-4 input-field">
        <PasswordInput
          v-model="formData.password"
          label="Your new password"
          :validation-errors="errors?.password"
          required
        />
      </div>

      <div class="mb-4 input-field">
        <PasswordInput
          v-model="formData.confirmPassword"
          label="Confirm your new password"
          :validation-errors="errors?.confirmPassword"
          required
        />
      </div>

      <div class="flex flex-col gap-3 text-center">
        <AppButton
          class="bg-primary text-white"
          :disabled="!canSubmit"
          :processing="isSubmitting"
          type="submit"
        >
          {{ isSubmitting ? 'Saving...' : 'Save' }}
        </AppButton>

        <template v-if="errors && 'token' in errors">
          <p class="text-red-500 p-2 mb-1 bg-red-100 rounded text-center">
            {{ errors.token[0] }}
          </p>
        </template>

        <RouterLink
          class="link"
          :to="{ name: 'app_auth_login' }"
        >
          <FontAwesomeIcon :icon="faChevronLeft" />
          Back to Sign in
        </RouterLink>
      </div>
    </div>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppButton } from '@/components/app';
import { PasswordInput } from '@/components/form-inputs';

import { useHttp } from '@/composables';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

const emit = defineEmits(['password-reset']);

const route = useRoute();

const formData = reactive({
  password: import.meta.env.DEV ? 'adminUser#123' : null,
  confirmPassword: import.meta.env.DEV ? 'adminUser#123' : null,
});
const isSubmitting = ref(false);
const errors = ref(null);
const canSubmit = computed(() => !isSubmitting.value && formData.confirmPassword === formData.password);

const handleSubmit = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post(
    '/auth/password-reset',
    { token: route.query.token, password: formData.password },
  );

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('password-reset');
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};
</script>
